import Swiper from "swiper";
import "swiper/css/effect-cards";
import PillarCards from "../modules/PillarCards";
import { EffectCards, EffectCreative, FreeMode, Mousewheel, Pagination } from "swiper/modules";
import gsap from "gsap";
import ScrollTrigger from "gsap/dist/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

class Commitments {
	constructor() {
		this.init();
	}

	init() {
		this.initModules();
	}

	initModules() {
		// Init Modules here
		const pillarCards = document.querySelector("[js-pillar-card]");
		pillarCards && new PillarCards(pillarCards);

		const pillarCardsSlider = document.querySelector(".pillar__cards-slider");
		pillarCardsSlider && this.initPillarCardsSlider(pillarCardsSlider);

		const principlesSlider = document.querySelector(".principles__slider");
		principlesSlider && this.initPrinciplesSlider(principlesSlider);
	}

	initPillarCardsSlider(el) {
		this.pillarCardsSwiper = new Swiper(el, {
			modules: [EffectCards, EffectCreative],
			effect: "creative",
			creativeEffect: {
				limitProgress: 2,
				perspective: 1000,
				next: {
					translate: [0, -62, 0],
					scale: 0.95,
				},
				prev: {
					translate: [-500, 0, 0],
					scale: 0.75,
					rotate: [0, 0, -90],
				},
			},
		});
	}

	initPrincipleCardsAnimation() {
		const cards = gsap.utils.toArray(".principle__card");

		gsap.fromTo(
			cards,
			{
				xPercent: 200,
				yPercent: 50,
				scale: 0.5,
				skewY: 10,
				skewX: 10,
				rotate: -60,
				opacity: 0,
			},
			{
				xPercent: 0,
				yPercent: 0,
				scale: 1,
				skewY: 0,
				skewX: 0,
				rotate: 0,
				opacity: 1,
				duration: 1.2,
				ease: "power3.out",
				stagger: 0.065,
				scrollTrigger: {
					trigger: ".principles__slider-wrapper",
					start: "top +=60%",
				},
			}
		);
	}

	initPrinciplesSlider(el) {
		const pagination = el.querySelector(".swiper-pagination");

		this.principlesSlider = new Swiper(el, {
			slidesPerView: 1.2,
			spaceBetween: 30,
			modules: [Pagination, FreeMode, Mousewheel],
			pagination: {
				el: pagination,
			},
			breakpoints: {
				576: {
					slidesPerView: "auto",
					pagination: false,
					mousewheel: {
						enabled: true,
						sensitivity: 2,
					},
					freeMode: {
						enabled: true,
						momentumBounce: false,
					},
					allowTouchMove: false,
				},
			},
		});

		console.log(this.principlesSlider);

		// this.initPrincipleCardsAnimation();
	}
}

if (document.readyState === "loading") {
	// Loading hasn't finished yet
	window.addEventListener("DOMContentLoaded", () => new Commitments());
} else {
	// `DOMContentLoaded` has already fired
	new Commitments();
}
